module.exports = __webpack_public_path__ + "img/98.f07cf957.jpg";